import { render, staticRenderFns } from "./privacyZy.vue?vue&type=template&id=2519f450&scoped=true&"
import script from "./privacyZy.vue?vue&type=script&lang=js&"
export * from "./privacyZy.vue?vue&type=script&lang=js&"
import style0 from "./privacyZy.vue?vue&type=style&index=0&id=2519f450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2519f450",
  null
  
)

export default component.exports